import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import FerryForm from "../ferryForm/ferryForm";

export default class AddFerry extends React.Component {
    render() {
        return (
            <AddItem
                class="add-ferry"
                header= {i18n.t("dictionaries.ferries.actions.addFerry.header")}
                content={ <FerryForm isUpdate={false}/>}
            />
        );
    }
}
